import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
	mainBox: {
		paddingLeft: 88,
	},
}));
